module.exports = __webpack_public_path__ + "static/media/kit_bipedRobotBasic_bg.55b2ad84.png";